import React from 'react';
import PropTypes from 'prop-types';
import '../assets/styles.css'

const Button = ({ children, type, disabled, onClick, style }) => {
    return (
        <button
            className={`_kanis_button _kanis_${type}_button`}
            onClick={onClick}
            disabled={disabled}
            style={style}
        >
            {children}
        </button>
    );
}

export default Button;

Button.propTypes = {
    children: PropTypes.node,
    type: PropTypes.oneOf(['primary', 'outline']),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    style: PropTypes.object,
};